import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { OnChangeValue } from 'react-select';
import { FormInput, Modal } from 'src/components/molecules';
import { FormInputVariant, Option, TranscriptLanguages } from 'src/types';
import { casePageVm, translationModalOpenStateUpdated } from './Case.slice';

interface EventTranslationModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  onChange: (value: OnChangeValue<Option, boolean>) => void;
  currentLanguage: TranscriptLanguages;
  legalDescription: React.ReactNode;
  'data-testid'?: string;
}

export const EventTranslationModal = ({
  onConfirm,
  onCancel,
  onChange,
  currentLanguage,
  legalDescription,
  ...props
}: EventTranslationModalProps) => {
  const dispatch = useDispatch();
  const currentLanguageLabel = Object.keys(TranscriptLanguages).find(
    (key) =>
      TranscriptLanguages[key as keyof typeof TranscriptLanguages] ===
      currentLanguage,
  );
  const { translationModalOpenState } = useSelector(casePageVm);

  const setTranslationModalOpen = (isModalOpen: boolean) => {
    dispatch(translationModalOpenStateUpdated({ open: isModalOpen }));
  };

  return (
    <Modal
      open={Boolean(translationModalOpenState)}
      setOpen={setTranslationModalOpen}
      size="large"
      title="Translate report?"
      onConfirm={onConfirm}
      onCancel={onCancel}
      description={legalDescription}
      data-testid={props['data-testid']}
    >
      <FormInput
        data-testid="translation-modal-form-dropdown"
        variant={FormInputVariant.DROPDOWN}
        options={Object.keys(TranscriptLanguages).map((language) => ({
          label: language.replace('_', ' - '),
          value:
            TranscriptLanguages[language as keyof typeof TranscriptLanguages],
        }))}
        defaultValue={{
          value: currentLanguage ?? 'en-GB',
          label: currentLanguageLabel ?? 'English',
        }}
        onChange={onChange}
        isMulti={false}
        description="Select the language you would like to translate the report to."
      />
    </Modal>
  );
};
